import React, { useMemo, useCallback } from 'react';

import { useCurrentUser } from 'Auth';

import { MultiSelect } from '@gogame/components';

import PresetPickerMenu from './PresetPickerMenu';

const HomeDashboardPresetPicker = ({ options, value, loading, ...props }) => {
  const user = useCurrentUser();

  const optionsWithGroup = useMemo(() => {
    return (
      options &&
      options
        .map((opt) => {
          const own = opt.user.id === user.id;
          let group = '';
          if (opt.isPublic && !own) {
            group = 'Public presets';
          } else if (own) {
            group = 'My presets';
          }
          return {
            ...opt,
            group,
          };
        })
        .sort(({ group }) => (group === 'My presets' ? -1 : 1))
    );
  }, [options]);

  const renderValue = useCallback(
    (selectedOptions) => {
      if (!selectedOptions.length && (!value || !value.length)) {
        return '';
      }
      return `${loading ? value.length : selectedOptions.length} selected`;
    },
    [value, loading]
  );

  return (
    <MultiSelect
      options={optionsWithGroup}
      MenuComponent={PresetPickerMenu}
      dropdownWidth={500}
      renderValue={renderValue}
      value={value}
      loading={loading}
      disabled={loading}
      {...props}
    />
  );
};

export default HomeDashboardPresetPicker;
